function easyUId(a, b) {
  for (b = a = ''; a++ < 36; b += ~a % 5 | a * 3 & 4 ? (a ^ 15 ? 8 ^ Math.random() * (a ^ 20 ? 16 : 4) : 4).toString(16) : '-');

  return new Date().getTime().toString(36) + '-' + b;
}

function arraysEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (a == null || b == null || a.length !== b.length) {
    return false;
  }

  for (let i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) {
      return false;
    }
  }

  return true;
}

class Circle {
  constructor({
    listen,
    unlisten,
    filter,
    execute
  } = {}) {
    this.id = easyUId();

    this._listen = listen || (() => {});

    this._unlisten = unlisten || (() => {});

    this._filter = filter || this._defaultFilter;

    this._execute = execute || ((...args) => this._defaultExecute(...args));

    this._entries = new Map();
    this._lockCircle = false;
    this._observers = [];
    this._notifyWithContext = this.notify.bind(this);
  }

  subscribe(listener) {
    this._observers.push(listener);
  }

  notify(...args) {
    this._observers.map(listener => {
      listener(...args);
    });
  }

  getEntries() {
    return this._entries;
  }

  register({
    read,
    write,
    meta = {
      interval: 180
    }
  }) {
    let id = easyUId();

    this._entries.set(id, {
      read,
      write,
      meta,
      time: Date.now() - meta.interval - 1,
      args: []
    });

    if (this._entries.size === 1) {
      this._listen(this._notifyWithContext);
    }

    return id;
  }

  unregister(id) {
    this._entries.delete(id);

    if (this._entries.size === 0) {
      this._unlisten(this._notifyWithContext);
    }
  }

  filter(circleEntries, ...args) {
    return this._filter(circleEntries, ...args);
  }

  read(circleEntries, ...args) {
    const now = Date.now();
    return circleEntries.map(entry => {
      entry.time = now;
      entry.args = args;
      let payload = typeof entry.read === 'function' ? entry.read(...args) : null;
      return Object.assign({
        payload
      }, entry);
    });
  }

  write(circleEntries, ...args) {
    return circleEntries.map(entry => {
      if (typeof entry.write === 'function') {
        return entry.write(entry, ...args);
      }
    });
  }

  *execute(...args) {
    if (this._lockCircle || this._entries.size === 0) {
      return [];
    }

    this._lockCircle = true;
    let modifiedEntries = yield* this._execute(...args);
    this._lockCircle = false;
    const originalEntries = Array.from(this.getEntries().values());
    const isCallAllEntriesWithArgs = originalEntries.filter(entry => arraysEqual(entry.args, args)).length === originalEntries.length;

    if (!isCallAllEntriesWithArgs) {
      this.notify(...args);
    }

    return modifiedEntries;
  }

  _defaultFilter(circleEntries) {
    const now = Date.now();
    return Array.from(circleEntries.values()).filter(loopEntry => {
      return loopEntry.time + loopEntry.meta.interval <= now;
    });
  }

  *_defaultExecute(...args) {
    let circleEntries = this.getEntries();
    circleEntries = this.filter(circleEntries, ...args);
    circleEntries = (yield circleEntries) || circleEntries;
    circleEntries = this.read(circleEntries, ...args);
    circleEntries = (yield circleEntries) || circleEntries;
    circleEntries = this.write(circleEntries, ...args);
    return circleEntries;
  }

}

class Infinite {
  constructor() {
    this._circles = new Map();
    this._scheduledCircles = new Map();
    this._executionInterval = 30;
    this._nextExecutionTime = 0;
    this._isSuspendedExecution = false;
    this._suspendExecutionWithContext = this._suspendExecution.bind(this);
  }

  add(circle) {
    this._circles.set(circle.id, circle);

    circle.subscribe((...rest) => this._onChange(circle, ...rest));
  }

  remove(circle) {
    this._circles.delete(circle.id);
  }

  _onChange(circle, ...args) {
    this._scheduledCircles.set(circle.id, {
      circle,
      args
    });

    if (!this._nextExecutionTime) {
      this._nextExecutionTime = Date.now() + this._executionInterval;
    }

    if (!this._isSuspendedExecution) {
      this._suspendExecution();
    }
  }

  _execute(circles) {
    const iterators = circles.map(({
      circle,
      args
    }) => circle.execute(...args));
    let isNextStep = true;

    while (isNextStep) {
      isNextStep = !iterators.reduce((end, iterator) => end && iterator.next().done, true);
    }
  }

  _suspendExecution() {
    if (this._nextExecutionTime <= Date.now()) {
      this._nextExecutionTime = 0;

      let copyOfScheduledCircles = this._scheduledCircles.values();

      this._scheduledCircles = new Map();
      this._isSuspendedExecution = false;

      this._execute(Array.from(copyOfScheduledCircles));
    } else {
      this._isSuspendedExecution = true;

      if (this._requestAnimationFrame()) {
        this._requestAnimationFrame()(this._suspendExecutionWithContext);
      } else {
        setTimeout(this._suspendExecutionWithContext, 1000 / 60);
      }
    }
  }

  _requestAnimationFrame() {
    return typeof window !== undefined && window.requestAnimationFrame;
  }

}

const DEFAULT_INTERVAL = 50;
const circles = new Map();
const infinite = new Infinite();
const listeners = new Map();
let scrollInfo, resizeInfo;

function addCircle(eventType) {
  if (circles.has(eventType)) {
    return circles.get(eventType);
  }

  const circle = new Circle({
    listen: notify => {
      window.addEventListener(eventType, notify);
    },
    unlisten: notify => {
      window.removeEventListener(eventType, notify);
    }
  });

  if (eventType === 'scroll') {
    circle.register({
      meta: {
        interval: DEFAULT_INTERVAL
      },
      read: () => {
        scrollInfo = getScrollInfo();
      }
    });
  }

  if (eventType === 'resize') {
    circle.register({
      meta: {
        interval: DEFAULT_INTERVAL
      },
      read: () => {
        resizeInfo = getResizeInfo();
      }
    });
  }

  infinite.add(circle);
  circles.set(eventType, circle);
  return circle;
}

const getResizeInfo = function () {
  let lastWidth, lastHeight;
  return function () {
    const height = window.innerHeight;
    const width = window.innerWidth;
    const delta = {
      width: width - (lastWidth || 0),
      height: height - (lastHeight || 0)
    }; // Prevent delta from being 0

    if (lastHeight !== height) {
      lastHeight = height;
    }

    if (lastWidth !== width) {
      lastWidth = width;
    }

    return {
      delta,
      height,
      width
    };
  };
}();

const getScrollInfo = function () {
  let lastTop;
  return function () {
    // Handle negative scrolling on mobile devices
    const top = Math.max(0, window.scrollY || window.pageYOffset);
    const delta = top - (lastTop || 0); // Prevent delta from being 0

    if (lastTop !== top) {
      lastTop = top;
    }

    return {
      delta,
      top
    };
  };
}();

function subscribe(eventType, callback, options = {}) {
  const circle = addCircle(eventType);
  const id = circle.register({
    meta: {
      interval: options.throttleRate || DEFAULT_INTERVAL
    },
    read: () => {
      const payload = {
        type: eventType
      };

      if (eventType === 'scroll' || eventType === 'touchmove') {
        payload.scroll = scrollInfo;
      }

      if (eventType === 'resize') {
        payload.resize = resizeInfo;
      }

      return payload;
    },
    write: ({
      payload
    }) => callback(payload)
  });
  listeners.set(id, {
    callback,
    eventType
  });
  return {
    unsubscribe: () => circle.unregister(id)
  };
}

function unsubscribe(eventType, callback) {
  for (const {
    key,
    value
  } of listeners.entries()) {
    if (value.eventType === eventType && value.callback === callback) {
      circles.get(eventType).unregister(key);
    }
  }
}

export { subscribe, unsubscribe };
